/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_Accept_AllInputs */

const en_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept All`)
};

const de_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle akzeptieren`)
};

const fr_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout accepter`)
};

const es_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar todo`)
};

const it_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta tutto`)
};

const nl_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles accepteren`)
};

const pl_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaakceptuj wszystko`)
};

const fi_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksy kaikki`)
};

const da_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter alle`)
};

const sv_cookie_consent_accept_all = /** @type {(inputs: Cookie_Consent_Accept_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptera alla`)
};

/**
* | output |
* | --- |
* | "Accept All" |
*
* @param {Cookie_Consent_Accept_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_accept_all = /** @type {((inputs?: Cookie_Consent_Accept_AllInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_Accept_AllInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_accept_all(inputs)
	if (locale === "fr") return fr_cookie_consent_accept_all(inputs)
	if (locale === "es") return es_cookie_consent_accept_all(inputs)
	if (locale === "it") return it_cookie_consent_accept_all(inputs)
	if (locale === "nl") return nl_cookie_consent_accept_all(inputs)
	if (locale === "pl") return pl_cookie_consent_accept_all(inputs)
	if (locale === "fi") return fi_cookie_consent_accept_all(inputs)
	if (locale === "da") return da_cookie_consent_accept_all(inputs)
	if (locale === "sv") return sv_cookie_consent_accept_all(inputs)
	return en_cookie_consent_accept_all(inputs)
});